(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["krtona-card-extras"] && !Shopify.designMode) return;
  try {
    window.krtonaQuickAdd = function (event, form) {
    event.preventDefault();
    var button = form.querySelector('button');
    if (!button || button.classList.contains('is-loading')) return false;
    button.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var variantId = Number(form.querySelector('[name="id"]').value);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        var label = button.querySelector('.krt-card-atc__label');
        if (label && button.dataset.addedLabel) label.textContent = button.dataset.addedLabel;
        setTimeout(function () { window.location.reload(); }, 700);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        form.submit();
      });
    return false;
  };
  } catch(e) { console.error(e); }
})();

})();
